import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Tooltip } from "@renderbus/ui";
import QrcodeImg from "@/assets/images/qrcode.png";
import { QrcodeText, QrcodeType } from "../constants/cash-status";

export function AssistantQrcode({ type }: { type: QrcodeType }) {
  const { t } = useTranslation("topup");
  return (
    <LotteryAssistantCode
      isDuringActivity={type === QrcodeType.ActivityRecharge}
      isCashPrize={type === QrcodeType.CashPrize}
      isSubmitInformatione={type === QrcodeType.SumbitCashInformation}
    >
      <Tooltip
        color="rgba(0, 0, 0, 0.8)"
        className="qrcode-tooltip"
        placement="topLeft"
        title={
          <img
            src={QrcodeImg}
            alt=""
            style={{ height: "124px", padding: "2px 4px 0" }}
          />
        }
        tooltipText={<img src={QrcodeImg} alt="" />}
      />
      <div>
        {QrcodeText[type].map((item: string) => {
          return <span key={item}>{t(item)}</span>;
        })}
      </div>
    </LotteryAssistantCode>
  );
}

const LotteryAssistantCode = styled.div<{
  isDuringActivity: boolean;
  isCashPrize: boolean;
  isSubmitInformatione: boolean;
}>`
  height: 79px;
  background: ${(props) => (!props.isCashPrize ? "#232528" : "transparent")};
  border: ${(props) => (props.isDuringActivity ? "1px solid #404246" : "0")};
  border-radius: 4px;
  margin-top: 6px;
  display: flex;
  align-items: center;
  display: flex;
  padding: ${(props) => (props.isCashPrize ? "0 20px" : "0 20px  0 10px")};
  color: #9cacb0;
  margin-left: ${(props) => props.isSubmitInformatione && "110px"};
  margin-top: ${(props) => props.isCashPrize && "28px"};
  img {
    padding-right: 14px;
    height: ${(props) => (props.isCashPrize ? "78px" : "60px")};
  }
  span {
    display: block;
    line-height: 32px;
  }
  span:nth-child(2) {
    font-size: ${(props) => props.isSubmitInformatione && "12px"};
  }
  span:nth-child(1) {
    color: #e6f4f8;
    font-weight: 600;
    line-height: 1;
  }
`;
